"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InstantVfxStepArgs = void 0;
const uuid_1 = require("uuid");
class InstantVfxStepArgs {
    constructor(applyAt, type, wait = false) {
        this.applyAt = applyAt;
        this.type = type;
        this.wait = wait;
        this.__typeName = "Instant";
        this.id = (0, uuid_1.v4)();
    }
}
exports.InstantVfxStepArgs = InstantVfxStepArgs;
